<div class="wrapper">
    <header class="header navbar navbar-expand-md row">
        <h2 class="col col-sm-7">RTO Exam Preparation</h2>
        <div class="row col col-sm-5">
            <div class="login-btn col col-sm-6">
                <a href="index.html"><button class="btn-fill"><p>HOME</p></button></a>
            </div>            
            <div class="login-btn col col-sm-6">
                <a href="login.html"><button class="btn-fill"><p>LOGIN</p></button></a>
            </div>
        </div>        
    </header>

    <section class="container">
    
        <div *ngIf="!isgujarati">
            <div class="language"><a role="button" (click)="changetoguj()">ગુજરાતી માં ફેરવો..</a></div>
        </div>
        <div *ngIf="isgujarati">
            <div class="language"><a role="button" (click)="changetoeng()">Change to English..</a></div>
        </div>
        <div class="myque">	
            <div *ngFor="let q of jsondata | paginate: { itemsPerPage: 5, currentPage: page }; let index = index">
                <div class="question">                
                    <p>{{ ((page-1)*5) + index +1 }} . {{ q.que }}</p>
                    <div *ngIf="q.hasImg">
                        <div *ngIf="!isgujarati">
                            <img src="../../../assets/QueImg/{{ q.imgurl }}">
                        </div>
                        <div *ngIf="isgujarati">
                            <img src="../../../assets/QueImgGuj/{{ q.imgurl }}">
                        </div>
                        
                    </div>
                    <div class="option" *ngIf="q.ans == 1">
                        <input type="radio" checked>
                        <p>{{ q.op1 }}</p>
                    </div>
                    <div class="option" *ngIf="q.ans != 1">
                        <input type="radio" disabled>
                        <p>{{ q.op1 }}</p>
                    </div>
                    <div class="option" *ngIf="q.ans == 2">
                        <input type="radio" checked>
                        <p>{{ q.op2 }}</p>
                    </div>
                    <div class="option" *ngIf="q.ans != 2">
                        <input type="radio" disabled>
                        <p>{{ q.op2 }}</p>
                    </div>
                    <div class="option" *ngIf="q.ans == 0">
                        <input type="radio" checked>
                        <p>{{ q.op3 }}</p>
                    </div>
                    <div class="option" *ngIf="q.ans != 0">
                        <input type="radio" disabled>
                        <p>{{ q.op3 }}</p>
                    </div>                
                </div>
            </div>
            <pagination-controls (pageChange)="page = $event"></pagination-controls>
        </div>
        <hr>
        <div class="content-bottom row">                
            <div class="skip-que col col-md-12">                            
                <p>GO TO Question : </p>
                <input type="number" [(ngModel)]='pnum'/> 
                <button (click)="skiptopage()">Skip</button>                
            </div>
        </div>
        
    </section>

<footer class="footer">
    <h5>coyright &copy; 2020,MS-creation</h5>
</footer>

</div>
